import React, { useState } from 'react';
import { Form, Input, Upload, Button, message } from 'antd'; // Adicionei message para feedback
import { CloudUploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import styles from '../../assets/css/formulario.module.css';
import PoliticaPrivacidade from '../Politica';
import ReactInputMask from 'react-input-mask';
import { URL_whatsapp } from '../../../../service/api';

const Formulario = ({ selectedOption }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const [open, setOpen] = useState(false);

    // Função para formatar o payload conforme sua estrutura
    const formatPayload = (values) => {
        const now = new Date().toISOString();

        const cpfLimpo = values.cpf ? values.cpf.replace(/\D/g, '') : "";
        const telefoneLimpo = values.telefone ? values.telefone.replace(/\D/g, '') : "";


        return {
            id: "",
            contato: {
                nome: values.nome,
                cpf: cpfLimpo,
                email: values.email,
                telefone: telefoneLimpo
            },
            tipo: {
                id: "1"
            },
            dataCriacao: now,
            situacao: {
                id: "I"
            },
            dataSituacao: now
        };
    };

    const handleProcessarEnvio = async () => {
    try {
        setLoading(true);
        const values = await form.validateFields();
        const payload = formatPayload(values);

        // 1. Chamada de Verificação
        const resVerificar = await axios.post('https://portal.meucontadoronline.com.br/merp/rest/ordem-servico/vendas/verificar', payload);

        // Ajuste a verificação conforme o retorno real da sua API
        if (resVerificar.status === 204 || resVerificar.status === 200) {

            // 2. Chamada de Cadastro
            const resCadastrar = await axios.post('https://portal.meucontadoronline.com.br/merp/rest/ordem-servico/vendas/cadastrar', payload);

            if (resCadastrar.status === 200) {
                // 3. Preparar dados para a API local
                const servicosMap = {
                    abrir: "abrir uma empresa",
                    trocar: "trocar de contabilidade",
                    migrar: "Migrar de MEI para ME"
                };

                const param = {
                    telefone: payload.contato.telefone,
                    nome: payload.contato.nome,
                    servico: servicosMap[selectedOption?.id] || ""
                };

                // 4. Chamada para a API Local
                const response = await axios.post(`${URL_whatsapp}landing/chamar`, param);

                if (response.status === 200 || response.status === 204) {
                    message.success('Solicitação enviada com sucesso!');
                    form.resetFields(); // Limpa apenas após todo o sucesso
                }
            }
        } else {
            message.warning('Não foi possível prosseguir com a verificação.');
        }
    } catch (error) {
        console.error("Erro na operação:", error);
        const msg = error.response?.data?.mensagem || 'Ocorreu um erro ao processar a solicitação.';
        message.error(msg);
    } finally {
        setLoading(false);
    }
};

    return (
        <>
            <div className={styles['logo-upload-container']}>
                <div className={styles['logo-circle']}>
                    <CloudUploadOutlined />
                </div>
            </div>

            <div style={{
                color: "#1f1f1f",
                marginBottom: 30,
                marginTop: 20,
                textAlign: "center",
                fontSize: "clamp(18px, 5vw, 22px)" // Fonte fluida: diminui no mobile
            }}>
                <label>
                    {selectedOption?.id === "migrar" ? null : "Inicie a"}{" "}
                    <strong style={{ color: "#0056b3" }}>
                        <a href='https://www.meucontadoronline.com.br/abrir-empresa/' style={{ textDecoration: 'none', color: 'inherit' }}>
                            {selectedOption?.description_form || "sua jornada"}
                        </a>
                    </strong> de forma simples e rápida
                </label>
            </div>

            <Form form={form} layout="vertical">
                <div className={styles['billing-section']}>
                    <div>
                        <span className={styles['section-label']}>Nome</span>
                        <Form.Item name="nome" rules={[{ required: true, message: 'Campo obrigatório' }]}>
                            <Input placeholder="Nome Completo" />
                        </Form.Item>

                        <span className={styles['section-label']}>CPF</span>
                        <Form.Item name="cpf" rules={[{ required: true, message: 'Campo obrigatório' }]}>
                      

                            <ReactInputMask mask="999.999.999-99" maskChar={null}>
                                {(inputProps) => <Input {...inputProps} placeholder="XXX.XXX.XXX-XX" />}
                            </ReactInputMask>
                        </Form.Item>
                    </div>

                    <div>
                        <span className={styles['section-label']}>Email</span>
                        <Form.Item name="email" rules={[{ required: true, type: 'email', message: 'Email inválido' }]}>
                            <Input placeholder="Email" />
                        </Form.Item>

                        <span className={styles['section-label']}>Telefone</span>
                        <Form.Item name="telefone" rules={[{ required: true, message: 'Campo obrigatório' }]}>
                            <ReactInputMask mask="(99) 99999-9999" maskChar={null}>
                                {(inputProps) => <Input {...inputProps} placeholder="(00) 00000-0000" />}
                            </ReactInputMask>
                        </Form.Item>
                    </div>
                </div>

                <div>
                    <p style={{ color: "#4f4f4f" }}>
                        Não se preocupe, seus dados não serão utilizados para outra finalidade. Conheça nossa {' '}
                        <span onClick={()=> setOpen(true)} style={{ color: "#3154f1", cursor: "pointer" }}>
                            Política de privacidade.
                        </span>
                    </p>
                </div>

                <div style={{ textAlign: 'center', marginTop: 20 }}>
                    <Button
                        type="primary"
                        onClick={handleProcessarEnvio}
                        loading={loading}
                        block
                        style={{
                            maxWidth: 300,
                            height: 50,
                            borderRadius: 8,
                            fontSize: 16,
                            fontWeight: 600
                        }}
                    >
                        Enviar Solicitação
                    </Button>
                </div>

            </Form>


            {open && (
                <PoliticaPrivacidade open={open} setOpen={setOpen}/>
            )}
        </>
    );
};

export default Formulario;